import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'
import NewPrivateAudienceInterface from '../../../../../interface/report/new-private-audience.interface'

const PostPrivateAudienceService = (audience: NewPrivateAudienceInterface) => {
  return apiInstance.post(ApiPathConfig.AUDIENCE, audience)
}

export default PostPrivateAudienceService
